// The query string, read and written as query-string 7 did with its defaults
// (22 Oct 2026: the package was about 2 KB gzipped of gwmc.js, which sits at
// its 250 KB budget). Pinned by query.test.mjs.
//
//   parse('?b=2&a=x+y&a=z&flag')  -> { a: ['x y', 'z'], b: '2', flag: null }
//   stringify({ b: 2, a: ['x', 'y'], flag: null, gone: undefined })
//                                  -> 'a=x&a=y&b=2&flag'
//
// Keys in alphabetical order both ways, a repeated key an array, a key with
// no "=" null, undefined left out; '+' reads as a space; values encoded
// strictly (!'()* too).

const decode = s => {
  try { return decodeURIComponent(s.replace(/\+/g, ' ')) } catch (e) { return s }
}

const encode = v => encodeURIComponent(v).replace(/[!'()*]/g, c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`)

export const parse = search => {
  const out = {}
  String(search || '').replace(/^[?#&]/, '').split('&').forEach(part => {
    if (!part) return
    const i = part.indexOf('=')
    const key = decode(i === -1 ? part : part.slice(0, i))
    const value = i === -1 ? null : decode(part.slice(i + 1))
    out[key] = key in out ? [].concat(out[key], value) : value
  })
  const sorted = {}
  Object.keys(out).sort().forEach(k => { sorted[k] = out[k] })
  return sorted
}

export const stringify = obj => Object.keys(obj || {}).sort()
  .filter(k => obj[k] !== undefined)
  .flatMap(k => [].concat(obj[k]).filter(v => v !== undefined).map(v => (v === null ? encode(k) : `${encode(k)}=${encode(v)}`)))
  .join('&')
